import { classed } from "@tw-classed/core";
import { forwardRef } from "react";
import { Checkbox as CheckboxDaisy, type CheckboxProps } from "react-daisyui";

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(({ className, ...props }, ref) => {
  const classes = classed("rounded-md checked:text-white");

  return <CheckboxDaisy className={classes({ className })} {...props} ref={ref} />;
});
